export default "/assets/certification_footer-8b139a62db7223164a44361815d718650adda242ee1b2e2ef3e778df537f98b1.png";